import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { DelayTypeAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-delay-type-audit-list',
  templateUrl: './delay-type-audit-list.component.html',
  styleUrls: ['./delay-type-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DelayTypeAuditListComponent implements OnInit {
  @Input() delayTypeId: number;
  @Input() loading: boolean;
  @Input() delayTypeAudits: DelayTypeAudit[];

  @Output() loadDelayType = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadDelayType.emit(this.delayTypeId);
  }

  onNextPage() {
    this.nextPage.emit(this.delayTypeId);
  }
}
